import { GetGovernmentAgenciesResponse } from 'api/premiumUserAPI/specialServicesAPI'
import { CallAPIAction, Status } from 'api/types'
import { ObjectWithTranslation, ObjectWithTranslationFromBE } from 'common/types/transformedRespTypes'
import Actions from 'redux/actions'

type State = {
  data: Array<ObjectWithTranslation>
} & Status

const initialState: State = {
  data: [],
  isLoading: false,
  success: false,
  fail: false,
}

const convertResponseToState = (item: ObjectWithTranslationFromBE) => ({
  id: item.id,
  label: item.label,
  labelEn: item.label_en,
})

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.GET_GOVERNMENT_AGENCIES_ASYNC,
    Actions.GET_GOVERNMENT_AGENCIES_SUCCESS,
    Actions.GET_GOVERNMENT_AGENCIES_FAIL,
    GetGovernmentAgenciesResponse
  >,
) => {
  switch (action.type) {
    case Actions.GET_GOVERNMENT_AGENCIES_ASYNC:
    case Actions.GET_GOVERNMENT_AGENCIES_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }

    case Actions.GET_GOVERNMENT_AGENCIES_SUCCESS:
      return {
        ...state,
        ...action.status,
        data: action.payload.data.map(convertResponseToState).concat([
          {
            id: 0,
            label: 'اخرى',
            labelEn: 'Other',
          },
        ]),
      }

    default:
      return state
  }
}
